import { useEffect } from "react"
import { gsap } from "gsap"

const useAnimateIn = () => {
  // Animate
  useEffect(() => {
    gsap.fromTo(
      ".cb-page-header",
      {
        yPercent: -10,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.3,
        delay: 0.2,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-page-content",
      {
        yPercent: 1,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.5,
        delay: 0.3,
        ease: "power3.inOut",
      }
    )
  }, [])
}

export default useAnimateIn
